import { render } from "./ProdCategViewPage.vue?vue&type=template&id=3242628a&ts=true"
import script from "./ProdCategViewPage.vue?vue&type=script&lang=ts"
export * from "./ProdCategViewPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__